// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TitleContainer_titleContainer__1aM40"};